import { ValidationErrors } from '../../../hooks/use-edit-form'
import LookupField from '../../wells/lookup-field'
import { AdditionalDocumentEdit } from '../../../../types/form-types'
import { FormField, NewOrUploadedFile, ReadOnlyField, TextInput } from '@msaf/core-react'

export type WellFileProps = NewOrUploadedFile & {
  documentType: string
  documentTitle: string
  author: string
}

export default function WellFileMetadata(
  file: WellFileProps,
  isEditable: boolean,
  validationErrors: ValidationErrors<AdditionalDocumentEdit>,
  isAGSUpload?: boolean,
  updateFile?: (fileId: string, props: Partial<WellFileProps>) => void,
) {
  return (
    <>
      <FormField
        validationMessages={validationErrors?.documentType}
        labelId='documentType'
        label='Document type'
        isRequired
      >
        {isEditable ? (
          <LookupField
            fieldFilters={isAGSUpload ? { name: 'AGS borelog' } : undefined}
            labelledBy='documentType'
            fieldId='documentType'
            value={file.documentType ?? ''}
            setValue={({ value }) => updateFile?.(file.id, { documentType: value })}
            menuPortalTarget={isAGSUpload ? null : undefined}
            isInvalid={!!validationErrors?.documentType}
          />
        ) : (
          <ReadOnlyField value={file.documentType ?? ''} labelledBy='title' />
        )}
      </FormField>
      <FormField
        validationMessages={validationErrors?.documentTitle}
        labelId='documentTitle'
        label='Document title'
        isRequired
      >
        {isEditable ? (
          <TextInput
            id='documentTitle'
            value={file.documentTitle ?? ''}
            onChange={(e) => updateFile?.(file.id, { documentTitle: e.target.value })}
            isInvalid={!!validationErrors?.documentTitle}
          />
        ) : (
          <ReadOnlyField value={file.documentTitle ?? ''} labelledBy='documentTitle' />
        )}
      </FormField>
      <FormField validationMessages={validationErrors?.author} labelId='author' label='Author' isRequired>
        {isEditable ? (
          <TextInput
            id='author'
            value={file.author ?? ''}
            onChange={(e) => updateFile?.(file.id, { author: e.target.value })}
            isInvalid={!!validationErrors?.author}
          />
        ) : (
          <ReadOnlyField value={file.author ?? ''} labelledBy='author' />
        )}
      </FormField>
    </>
  )
}
